import CoinIcon from '@/shared/ui/CoinIcon';
import { trimTxHash } from '@/shared/utils/formatters'

type TxHashCellProps = {
  coin: string,
  hash?: string,
  explorer?: string,
}

const TxHashCell = (props: TxHashCellProps) => {
  const { 
    coin, 
    hash = '',
  } = props;
  return <span className='text-sm'>
    {hash ? (
      <span className='inline-flex'>
        <CoinIcon coin={coin} className='h-3 mr-1.5'/>
        <span>{trimTxHash(hash)}</span>
      </span>
    ) : (
      <span className='text-white/[0.3]'>~</span>
    )}
  </span>;
}

export default TxHashCell;